import { useTranslation } from 'react-i18next';

interface Props {
  pageNumber: number;
  totalPages: number;
}

const ReportPreviewPageFooter = ({ pageNumber, totalPages }: Props) => {
  const { t } = useTranslation();

  return (
    <footer
      className="tw-mt-auto tw-flex tw-items-center tw-justify-between tw-border-t tw-border-grayscale-20 tw-pt-4"
      data-cy="analytics_report_preview-page-footer"
    >
      <span className="tw-text-xs tw-font-medium tw-text-grayscale-180">
        {t('analyticsReports.pagination', {
          current: pageNumber,
          total: totalPages,
        })}
      </span>
      <p className="tw-text-xs tw-text-grayscale-100">
        {t('analyticsReports.createReport.previewGeneratedBy')}{' '}
        <a
          href="https://kontentino.com"
          target="_blank"
          rel="noopener noreferrer"
          className="tw-underline"
        >
          Kontentino
        </a>
      </p>
    </footer>
  );
};

export default ReportPreviewPageFooter;
